import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import _ from 'lodash'
// import useScanDetection from "use-scan-detection";
import { addProduct, addProductImage, getProductType } from "./Product.action";
import { setHeading } from "../../../accounts/account.actions";
import { getSubCategoryWithCategoryIdApi } from "../subCategory/SubCategory.action";
import { getCategoryWithWarehouseApi } from "../categories/Catagory.action";
import { getWarehouseApi } from "../Warehouse/Warehouse.action";
import { getRestaurantData } from "../AddResturant/Resturant.action";
import { getBrandApi } from "../Brand/Brand.action";
import { getSizeData } from "../AddSize/Size.action";
import { getFlavorsData } from "../AddColour/Colour.action";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import { getVendorData } from "../Vendor/Vendor.action";
import { GetUOMApi } from "../AddUOM/Uom.action";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import "jspdf-autotable";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import Select from "react-select";
import ImageUploader from "react-images-upload";


const AddProduct = (props) => {
  const [product, setProduct] = useState("");
  const [uomId, setUomId] = useState();
  const [uomname, setUomName] = useState();
  const [salePrice, setsalePrice] = useState();
  const [code, setCode] = useState("");
  const [minimumBalance, setMinimumBalance] = useState("");
  const [maximumBalance, setMaximumBalance] = useState("");
  const [warranty, setWarranty] = useState();
  const [purchasePrice, setPurchasePrice] = useState("");
  const [wholesalePrice, setWholesalePrice] = useState("");
  const [productQuantity, setProductQuantity] = useState();
  const [productDesc, setProductDesc] = useState()
  const [barcode, setBarcode] = useState();
  const [warehouseId, setWarehouseId] = useState();
  const [warehouseName, setWarehouseName] = useState();
  const [retaurantId, setRestaurantId] = useState();
  const [restaurantName, setRestaurantName] = useState();
  const [CategoryId, setCategoryId] = useState();
  const [Categoryname, setCategoryName] = useState();
  const [subCategoryId, setSubCategoryId] = useState();
  const [subCategoryname, setSubCategoryName] = useState();
  const [brandId, setBrandId] = useState();
  const [brandName, setBrandName] = useState();
  const [vendorId, setVendorId] = useState();
  const [vendorName, setVendorName] = useState();
  const [TypeId, setTypeId] = useState("6433dd117aad3eb039c17451");
  const [Typename, setTypeName] = useState("Simple Product");
  const [piecePerBox, setPiecePerBox] = useState("");
  const [inputField, setInputField] = useState([{
    colourLabel: "",
    sizeLabel: "",
    productBalance: 0,
    salePrice: 0,
    purchasePrice: 0,
  }]);


  function uploadSimpleProduct() {
    props.addProduct({
      wareHouseId: warehouseId,
      warehouseName: warehouseName,
      retaurantId: retaurantId,
      category: CategoryId,
      categoryName: Categoryname,
      subCategoryId: subCategoryId,
      name: product,
      desc: productDesc,
      uom: uomId,
      uomLabel: uomname,
      code: code,
      salePrice: salePrice,
      maximumBalance: maximumBalance,
      minimumBalance: minimumBalance,
      purchasePrice: purchasePrice,
      wholesalePrice: wholesalePrice,
      productBalance: productQuantity,
      images: props.ProductImageURL.file,
      barcodeId: barcode,
      warranty: warranty,
      brandId: brandId,
      brandName: brandName,
      productType: TypeId,
      vendorId: vendorId,
      vendorName: vendorName,
      piecePerBox: piecePerBox,
    },
      showSuccessAlert,
      showErrorAlert
    );
    setRestaurantId("")
    setRestaurantName("")
    setCategoryId("")
    setCategoryName("")
    setSubCategoryId("")
    setSubCategoryName("")
    setCode("");
    setProduct("");
    setProductDesc("");
    setUomName("");
    setUomId("");
    setPurchasePrice("");
    setsalePrice("");
    setWholesalePrice("")
    setProductQuantity("");
    setMinimumBalance("");
    setMaximumBalance("");
    setWarranty("");
    setBarcode("");
    setWarehouseId("")
    setWarehouseName("")
    // setBrandId("")
    setBrandName("")
    setVendorId("")
    setVendorName("")
    setPiecePerBox("")
  }
  function uploadVariationProduct() {
    props.addProduct({
      wareHouseId: warehouseId,
      warehouseName: warehouseName,
      retaurantId: retaurantId,
      category: CategoryId,
      categoryName: Categoryname,
      subCategoryId: subCategoryId,
      name: product,
      desc: productDesc,
      uom: uomId,
      uomLabel: uomname,
      code: code,
      // maximumBalance: maximumBalance,
      // minimumBalance: minimumBalance,
      // productBalance: productQuantity,
      images: props.ProductImageURL.file,
      barcodeId: barcode,
      warranty: warranty,
      brandId: brandId,
      brandName: brandName,
      variation: inputField,
      productType: TypeId,
    },
      showSuccessAlert,
      showErrorAlert
    );
    setRestaurantName("")
    setCategoryName("")
    setSubCategoryName("")
    setCode("");
    setProduct("");
    setProductDesc("");
    setUomName("");
    setUomId("");
    setPurchasePrice("");
    setsalePrice("");
    setProductQuantity("");
    setMinimumBalance("");
    setMaximumBalance("");
    setWarranty("");
    setBarcode("");
    setWarehouseName("")
    setBrandName("")
    setInputField([
      {
        flavorLabel: "",
        sizeLabel: "",
        productBalance: 0,
        salePrice: 0,
        purchasePrice: 0,
      },
    ]);
  }

  const onDrop = (pictureFiles, pictureDataURLs) => {
    props.ProductImage({
      image: pictureFiles[0],
    });
    //setUploadImage(pictureFiles);
  };

  // const permissions = JSON.parse(window.localStorage.getItem("permissions"))
  // const Checkpermissions = (permissionsType, permissionsName) => {
  //   return permissions.some(p => p[`${permissionsType}`] === permissionsName) ? true : false
  // }

  // useScanDetection(
  //   Checkpermissions("permissionsCatName", "Enable Barcode") && {
  //     onComplete: setBarcode,
  //     //  minLength: 13 // EAN13
  //   });

  const handleChangeWarehouse = (selectedOption) => {
    setWarehouseId(selectedOption.value);
    setWarehouseName(selectedOption.label);
    // props.getCategoryWithWarehouseApi(selectedOption.value);
  };
  const getWarehouseList = props.warehouseList?.data?.length ? props.warehouseList?.data.map(x => ({
    value: x._id,
    label: x.businessName,
  })) : [];

  const handleChangeRestaurant = (selectedOption) => {
    setRestaurantId(selectedOption.value);
    setRestaurantName(selectedOption.label);
    props.getCategoryWithWarehouseApi(selectedOption.value);
  };
  const getRetaurantList = props.restaurantDataList?.length ? props.restaurantDataList.map(x => ({
    value: x._id,
    label: x.restaurantName,
  })) : [];

  const handleChangeCategory = (selectedOption) => {
    setCategoryId(selectedOption.value);
    setCategoryName(selectedOption.label);
    props.getSubCategoryWithCategoryIdApi(selectedOption.value);
  };
  const getCategoryList = props.categoryListByWarehouseId?.data?.length ? props.categoryListByWarehouseId?.data.map(x => ({
    value: x._id,
    label: x.name,
  })) : [];

  const handleChangeSubCategory = (selectedOption) => {
    setSubCategoryId(selectedOption.value);
    setSubCategoryName(selectedOption.label);
  };
  const getSubCategoryList = props.subCategoryListByCategoryId?.length ? props.subCategoryListByCategoryId.map(x => ({
    value: x._id,
    label: x.subCategoryName,
  })) : [];

  const handleChangeUom = (selectedOption) => {
    setUomId(selectedOption.value);
    setUomName(selectedOption.label);
  };
  const getUomList = !_.isEmpty(props.UOMList) && props.UOMList.map((x) => {
    let data = { value: x._id, label: x.unitName };
    return data;
  });

  const handleChangeBrand = (selectedOption) => {
    setBrandId(selectedOption.value);
    setBrandName(selectedOption.label);
  };
  const getBrandList = props.brandDataList?.length ? props.brandDataList.map(x => ({
    value: x._id,
    label: x.brandName,
  })) : [];

  // const handleChangeType = (selectedOption) => {
  //   setTypeId(selectedOption.value);
  //   setTypeName(selectedOption.label);
  // };
  // const gettypeList = props.productTypeList?.length ? props.productTypeList.map(x => ({
  //   value: x._id,
  //   label: x.productTypeName,
  // })) : [];

  const handleChangeVendor = (selectedOption) => {
    setVendorId(selectedOption.value);
    setVendorName(selectedOption.label);
  };
  const getVendorList = props.vendorDataList?.length ? props.vendorDataList.map(x => ({
    value: x._id,
    label: x.vendorName,
  })) : [];

  const inventorySize = props.sizeDataList.map((x) => {
    let data = {
      value: x._id,
      label: x.sizeName,
    };
    return data;
  });

  const inventoryFlavor = props.flavorsDataList.map((x) => {
    let data = {
      value: x._id,
      label: x.colourName,
    };
    return data;
  });


  const handleChange = (e, index, type) => {
    // let z = find(props.allInventory, (x) => x._id == e.value);
    // const { name, value } = e;
    const list = [...inputField];
    if (type == "colour") list[index]["colourLabel"] = e.label;
    if (type == "size") list[index]["sizeLabel"] = e.label;
    if (type == "productBalance") list[index]["productBalance"] = Number(e.target.value);
    if (type == "price") list[index]["salePrice"] = Number(e.target.value);
    if (type == "purchasePrice") list[index]["purchasePrice"] = Number(e.target.value);
    setInputField(list);
  };
  const handleAddInput = () => {
    setInputField([
      ...inputField,
      { colourLabel: "", sizeLabel: "", productBalance: 0, salePrice: 0, purchasePrice: 0 },
    ]);
  };
  const handleRemoveInput = (index) => {
    const list = [...inputField];
    list.splice(index, 1);
    setInputField(list);
  };

  useEffect(() => {
    props.setHeading("New Product");
    props.GetUOMApi();
    props.getWarehouseApi();
    props.getRestaurantData();
    props.getBrandApi();
    props.getProductType();
    props.getSizeData();
    props.getFlavorsData();
    props.getVendorData();
    //props.resetState();
  }, []);

  return (
    <>
      {props.isAddingProduct || props.isFetchingRestaurant || props.isFetchingVendor ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          {/* <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Select Product Type *</b></Form.Label>
                <Select
                  isDisabled={_.isEmpty(props.productTypeList)}
                  value={{ label: Typename }}
                  placeholder="Select Product Type"
                  onChange={handleChangeType}
                  options={gettypeList}
                />
              </Form.Group>
            </Col>
          </Row> */}


          <div hidden={TypeId === "6433dd117aad3eb039c17451" ? false : true}> {/* SIMPLE PRODUCT */}
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Select Company *</b> </Form.Label>
                  <Select
                    value={{ label: restaurantName }}
                    placeholder="Select Company"
                    onChange={handleChangeRestaurant}
                    options={getRetaurantList}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Select Category *</b></Form.Label>
                  <Select
                    placeholder="Select Category"
                    isDisabled={_.isEmpty(props.categoryListByWarehouseId) || _.isEmpty(retaurantId)}
                    onChange={handleChangeCategory}
                    options={getCategoryList}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Select Sub Category *</b> </Form.Label>
                  <Select
                    placeholder="Select Sub Category"
                    value={{ label: subCategoryname }}
                    isDisabled={_.isEmpty(props.subCategoryListByCategoryId) || _.isEmpty(CategoryId)}
                    onChange={handleChangeSubCategory}
                    options={getSubCategoryList}
                  />
                </Form.Group>
              </Col>
            </Row>
            {/* <Row>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Select Vendor *</b> </Form.Label>
                  <Select
                    isDisabled={_.isEmpty(subCategoryId)}
                    placeholder="Select Vendor"
                    onChange={handleChangeVendor}
                    options={getVendorList}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Select Business Location *</b> </Form.Label>
                  <Select
                    isDisabled={_.isEmpty(subCategoryId)}
                    placeholder="Select Business Location"
                    onChange={handleChangeWarehouse}
                    options={getWarehouseList}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Select UOM *</b></Form.Label>
                  <Select
                    isDisabled={_.isEmpty(props.UOMList) || _.isEmpty(subCategoryId)}
                    placeholder="Select UOM"
                    onChange={handleChangeUom}
                    options={getUomList}
                  />
                </Form.Group>
              </Col>
            </Row> */}
            <Row>
              {/* <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label> <b>Code / SKU</b></Form.Label>
                  <Form.Control
                    disabled={_.isEmpty(subCategoryId) ? true : false}
                    type="text"
                    placeholder="Code"
                    onChange={(e) => setCode(e.target.value)}
                  />
                </Form.Group>
              </Col> */}
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Product Name *</b> </Form.Label>
                  <Form.Control
                    disabled={_.isEmpty(subCategoryId) ? true : false}
                    type="text"
                    placeholder="Product Name"
                    onChange={(e) => setProduct(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Product Quantity *</b></Form.Label>
                  <Form.Control
                    disabled={_.isEmpty(subCategoryId) ? true : false}
                    type="Number"
                    placeholder="Product Quantity"
                    onChange={(e) => setProductQuantity(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label> <b>Purchase Price *</b> </Form.Label>
                  <Form.Control
                    type="Number"
                    disabled={_.isEmpty(subCategoryId) ? true : false}
                    placeholder="Purchase Price"
                    min={0}
                    onChange={(e) => setPurchasePrice(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label> <b>Sale Price *</b> </Form.Label>
                  <Form.Control
                    type="Number"
                    disabled={_.isEmpty(subCategoryId) ? true : false}
                    placeholder="Sale Price"
                    min={0}
                    onChange={(e) => setsalePrice(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label> <b>WholeSale Price *</b> </Form.Label>
                  <Form.Control
                    type="Number"
                    disabled={_.isEmpty(subCategoryId) ? true : false}
                    placeholder="WholeSale Price"
                    min={0}
                    onChange={(e) => setWholesalePrice(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              {/* <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Piece Per Box </b></Form.Label>
                  <Form.Control
                    disabled={_.isEmpty(subCategoryId) ? true : false}
                    type="Number"
                    placeholder="Pieces Per Box"
                    onChange={(e) => setPiecePerBox(e.target.value)}
                  />
                </Form.Group>
              </Col> */}
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label> <b>Product Description </b></Form.Label>
                  <Form.Control
                    disabled={_.isEmpty(subCategoryId) ? true : false}
                    type="text"
                    placeholder="Product Description"
                    onChange={(e) => setProductDesc(e.target.value)}
                  />
                </Form.Group>
              </Col>
              {/* <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Select Brand </b></Form.Label>
                  <Select
                    // value={{ label: brandName }}
                    isDisabled={_.isEmpty(props.brandDataList) || _.isEmpty(subCategoryId)}
                    placeholder="Select Brand"
                    onChange={handleChangeBrand}
                    options={getBrandList}
                  />
                </Form.Group>
              </Col> */}
            </Row>
            {/* <Row>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label> <b>Bar Code Scaner</b> </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Bar Code Number"
                    value={barcode}
                    disabled
                    onBlur={(e) => setBarcode(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label> <b>Minimum Balance </b></Form.Label>
                  <Form.Control
                    disabled={_.isEmpty(subCategoryId) ? true : false}
                    type="Number"
                    placeholder="Minimum Balance"
                    onChange={(e) => setMinimumBalance(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Maximum Balance </b></Form.Label>
                  <Form.Control
                    disabled={_.isEmpty(subCategoryId) ? true : false}
                    type="Number"
                    placeholder="Maximum Balance"
                    onChange={(e) => setMaximumBalance(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Warranty </b></Form.Label>
                  <Form.Control
                    disabled={_.isEmpty(subCategoryId) ? true : false}
                    type="text"
                    placeholder="Warranty"
                    onChange={(e) => setWarranty(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row> */}

            {/* <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label> <b style={{ fontSize: "large" }}> Upload Product Image </b></Form.Label>
                  <ImageUploader
                    withIcon={false}
                    buttonText="Upload Product Image"
                    onChange={onDrop}
                    // onChange = {(e) => setUploadCnicImage(e.target.files[0])}
                    imgExtension={[".jpg", ".jpeg", ".png"]}
                    maxFileSize={999999999999999999999}
                    singleImage={true}
                    withPreview={true}
                  />
                </Form.Group>
              </Col>
            </Row> */}

            <div className="sendDiv">
              {_.isEmpty(product) || _.isEmpty(productQuantity) || _.isEmpty(purchasePrice) || _.isEmpty(wholesalePrice) || _.isEmpty(salePrice) ? (
                <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
              ) : (
                <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={uploadSimpleProduct}> SAVE </Button>
              )}
            </div>
          </div>


          <div hidden={TypeId === "6433dd117aad3eb039c17450" ? false : true}> {/* VARIATION PRODUCT */}
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Select Company *</b></Form.Label>
                  <Select
                    value={{ label: restaurantName }}
                    placeholder="Select Company"
                    onChange={handleChangeRestaurant}
                    options={getRetaurantList}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Select Category *</b> </Form.Label>
                  <Select
                    placeholder="Select Category"
                    isDisabled={_.isEmpty(props.categoryListByWarehouseId) || _.isEmpty(retaurantId)}
                    onChange={handleChangeCategory}
                    options={getCategoryList}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Select Sub Category *</b></Form.Label>
                  <Select
                    placeholder="Select Sub Category"
                    value={{ label: subCategoryname }}
                    isDisabled={_.isEmpty(props.subCategoryListByCategoryId) || _.isEmpty(CategoryId)}
                    onChange={handleChangeSubCategory}
                    options={getSubCategoryList}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Code </b></Form.Label>
                  <Form.Control
                    disabled={_.isEmpty(subCategoryId) ? true : false}
                    type="text"
                    placeholder="Code"
                    onChange={(e) => setCode(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Product Name *</b></Form.Label>
                  <Form.Control
                    disabled={_.isEmpty(subCategoryId) ? true : false}
                    type="text"
                    placeholder="Product Name"
                    onChange={(e) => setProduct(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label> <b>Product Description </b></Form.Label>
                  <Form.Control
                    disabled={_.isEmpty(subCategoryId) ? true : false}
                    type="text"
                    placeholder="Product Description"
                    onChange={(e) => setProductDesc(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            {/* <Row >
                  <Col>
                    <Form.Group className="mb-3" controlId="garana">
                      <Form.Label>
                        <b>Product Quantity *</b>
                      </Form.Label>
                      <Form.Control
                        disabled={_.isEmpty(subCategoryId) ? true : false}
                        type="Number"
                        placeholder="Product Quantity"
                        onChange={(e) => setProductQuantity(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="garana">
                      <Form.Label>
                        <b>Minimum Balance </b>
                      </Form.Label>
                      <Form.Control
                        disabled={_.isEmpty(subCategoryId) ? true : false}
                        type="Number"
                        placeholder="Minimum Balance"
                        onChange={(e) => setMinimumBalance(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="garana">
                      <Form.Label>
                        <b>Maximum Balance </b>
                      </Form.Label>
                      <Form.Control
                        disabled={_.isEmpty(subCategoryId) ? true : false}
                        type="Number"
                        placeholder="Maximum Balance"
                        onChange={(e) => setMaximumBalance(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row> */}
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label> <b>Warranty </b></Form.Label>
                  <Form.Control
                    disabled={_.isEmpty(subCategoryId) ? true : false}
                    type="text"
                    placeholder="Warranty"
                    onChange={(e) => setWarranty(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Bar Code Scaner</b></Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Bar Code Number"
                    value={barcode}
                    disabled
                    onBlur={(e) => setBarcode(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Select Brand </b></Form.Label>
                  <Select
                    // value={{ label: brandName }}
                    isDisabled={_.isEmpty(props.brandDataList) || _.isEmpty(subCategoryId)}
                    placeholder="Select Brand"
                    onChange={handleChangeBrand}
                    options={getBrandList}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label> <b>Select Business Location *</b></Form.Label>
                  <Select
                    isDisabled={_.isEmpty(subCategoryId)}
                    placeholder="Select Business Location"
                    onChange={handleChangeWarehouse}
                    options={getWarehouseList}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Select UOM *</b> </Form.Label>
                  <Select
                    placeholder="Select UOM"
                    onChange={handleChangeUom}
                    options={getUomList}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Select Vendor *</b> </Form.Label>
                  <Select
                    isDisabled={_.isEmpty(subCategoryId)}
                    placeholder="Select Vendor"
                    onChange={handleChangeVendor}
                    options={getVendorList}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg="12" md="12" sm="12">
                <Form.Group>
                  <Form.Label><b>Select Variation *</b></Form.Label>
                  {inputField.map((item, i) => {
                    return (
                      <React.Fragment key={i}>
                        <Row >
                          <Col>
                            <Form.Group>
                              <Form.Label><b> Select Color *</b></Form.Label>
                              <Select
                                style={{ zIndex: 1 }}
                                value={{ label: item.colourLabel }}
                                placeholder="Select Color"
                                name="colour"
                                onChange={(e) => handleChange(e, i, "colour")}
                                options={inventoryFlavor}
                              />
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group>
                              <Form.Label><b> Select Size *</b></Form.Label>
                              <Select
                                style={{ zIndex: 1 }}
                                value={{ label: item.sizeLabel }}
                                placeholder="Select Size"
                                name="size"
                                onChange={(e) => handleChange(e, i, "size")}
                                options={inventorySize}
                                isOptionDisabled={(option) => !_.isEmpty(_.find(inputField, (x) => x.sizeId == option.value))}
                              />
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label><b>Product Balance *</b></Form.Label>
                              <Form.Control
                                min={0}
                                type="number"
                                placeholder="Product Balance"
                                name="productBalance"
                                value={item.productBalance}
                                onChange={(e) => handleChange(e, i, "productBalance")}
                              />
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label><b>Purchase Price *</b></Form.Label>
                              <Form.Control
                                min={0}
                                type="number"
                                placeholder="Purchase Price"
                                name="purchasePrice"
                                value={item.purchasePrice}
                                onChange={(e) => handleChange(e, i, "purchasePrice")}
                              />
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label><b>Sale Price *</b></Form.Label>
                              <Form.Control
                                min={0}
                                type="number"
                                placeholder="Sale Price"
                                name="salePrice"
                                value={item.salePrice}
                                onChange={(e) => handleChange(e, i, "price")}
                              />
                            </Form.Group>
                          </Col>

                          <Col style={{ marginTop: "2.5%" }}>
                            <Form.Group>
                              {inputField.length - 1 == i && (
                                <Button
                                  title="Click to Add Product Variation"
                                  onClick={handleAddInput}
                                  style={{ float: "right", backgroundColor: '#81abd3', color: 'white' }}
                                >
                                  <AddIcon />
                                </Button>
                              )}

                              {inputField.length !== 1 && (
                                <Button
                                  title="Click to Remove Product Variation"
                                  onClick={() => handleRemoveInput(i)}
                                  style={{ float: "right", backgroundColor: '#81abd3', color: 'white', marginRight: '20px' }}
                                >
                                  <RemoveIcon />
                                </Button>
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      </React.Fragment>
                    );
                  })}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label> <b style={{ fontSize: "large" }}> Upload Product Image </b> </Form.Label>
                  <ImageUploader
                    withIcon={false}
                    buttonText="Upload Product Image"
                    onChange={onDrop}
                    // onChange = {(e) => setUploadCnicImage(e.target.files[0])}
                    imgExtension={[".jpg", ".jpeg", ".png"]}
                    maxFileSize={999999999999999999999}
                    singleImage={true}
                    withPreview={true}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="sendDiv">
              {_.isEmpty(product) || _.isEmpty(uomId) || _.isEmpty(retaurantId) || _.isEmpty(vendorId) || _.isEmpty(warehouseId) || inputField.some((fields) => _.isEmpty(fields.colourLabel) || _.isEmpty(fields.sizeLabel) || fields.productBalance <= 0 || fields.salePrice <= 0) ? (
                <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
              ) : (
                <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={uploadVariationProduct}> SAVE </Button>
              )}
            </div>
          </div>

        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    addProduct: (data, showSuccessAlert, showErrorAlert) => dispatch(addProduct(data, showSuccessAlert, showErrorAlert)),
    GetUOMApi: () => dispatch(GetUOMApi()),
    getBrandApi: () => dispatch(getBrandApi()),
    ProductImage: (data) => dispatch(addProductImage(data)),
    getWarehouseApi: () => dispatch(getWarehouseApi()),
    getRestaurantData: () => dispatch(getRestaurantData()),
    getCategoryWithWarehouseApi: (id) => dispatch(getCategoryWithWarehouseApi(id)),
    getSubCategoryWithCategoryIdApi: (id) => dispatch(getSubCategoryWithCategoryIdApi(id)),
    setHeading: (data) => dispatch(setHeading(data)),
    getProductType: () => dispatch(getProductType()),
    getSizeData: () => dispatch(getSizeData()),
    getFlavorsData: () => dispatch(getFlavorsData()),
    getVendorData: () => dispatch(getVendorData()),
    // reset: () => dispatch(resetReducer()),
  };
};
const mapStateToProps = (state, ownProps) => ({
  productTypeList: state.ProductReducer.productTypeList,
  productList: state.ProductReducer.productList,
  isFetchingUOM: state.uomReducer.isFetchingUOM,
  UOMList: state.uomReducer.UOMList,
  ProductImageURL: state.ProductReducer.ProductImageURL,
  isAddingProduct: state.ProductReducer.isAddingProduct,
  subCategoryListByCategoryId: state.SubCategoryReducer.subCategoryListByCategoryId,
  isFetchingSubCategoryListByCategoryId: state.SubCategoryReducer.isFetchingSubCategoryListByCategoryId,
  warehouseList: state.WarehouseReducer.warehouseList,
  isFetchingWarehouseList: state.WarehouseReducer.isFetchingWarehouseList,
  categoryListByWarehouseId: state.CategoryReducer.categoryListByWarehouseId,
  isFetchingCategoryByWarehouseId: state.CategoryReducer.isFetchingCategoryByWarehouseId,
  brandDataList: state.brandReducer.brandDataList,
  isFetchingBrand: state.brandReducer.isFetchingBrand,
  restaurantDataList: state.ResturantReducer.restaurantDataList,
  sizeDataList: state.sizeReducer.sizeDataList,
  isFetchingSize: state.sizeReducer.isFetchingSize,
  flavorsDataList: state.ColourReducer.flavorsDataList,
  isFetchingFlavors: state.ColourReducer.isFetchingFlavors,
  isFetchingVendor: state.VendorReducer.isFetchingVendor,
  vendorDataList: state.VendorReducer.vendorDataList,
});


export default connect(mapStateToProps, mapDispatchToProps)(AddProduct);